import { render, staticRenderFns } from "./RegexSet.vue?vue&type=template&id=ae3978ba&"
import script from "./RegexSet.vue?vue&type=script&lang=js&"
export * from "./RegexSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports